module.exports = __webpack_public_path__ + "components/flag/static/square/sx-fd2c3514832a976446cdb1ab05b8e66c.svg";